/*!
 * devextreme-angular
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import {
    NestedOptionHost,
} from 'devextreme-angular-rpk/core';
import { NestedOption } from 'devextreme-angular-rpk/core';


@Component({
    selector: 'dxo-default-item-properties',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoDefaultItemPropertiesComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get connectorLineEnd(): string {
        return this._getOption('connectorLineEnd');
    }
    set connectorLineEnd(value: string) {
        this._setOption('connectorLineEnd', value);
    }

    @Input()
    get connectorLineStart(): string {
        return this._getOption('connectorLineStart');
    }
    set connectorLineStart(value: string) {
        this._setOption('connectorLineStart', value);
    }

    @Input()
    get connectorLineType(): string {
        return this._getOption('connectorLineType');
    }
    set connectorLineType(value: string) {
        this._setOption('connectorLineType', value);
    }

    @Input()
    get shapeMaxHeight(): number {
        return this._getOption('shapeMaxHeight');
    }
    set shapeMaxHeight(value: number) {
        this._setOption('shapeMaxHeight', value);
    }

    @Input()
    get shapeMaxWidth(): number {
        return this._getOption('shapeMaxWidth');
    }
    set shapeMaxWidth(value: number) {
        this._setOption('shapeMaxWidth', value);
    }

    @Input()
    get shapeMinHeight(): number {
        return this._getOption('shapeMinHeight');
    }
    set shapeMinHeight(value: number) {
        this._setOption('shapeMinHeight', value);
    }

    @Input()
    get shapeMinWidth(): number {
        return this._getOption('shapeMinWidth');
    }
    set shapeMinWidth(value: number) {
        this._setOption('shapeMinWidth', value);
    }

    @Input()
    get style(): any {
        return this._getOption('style');
    }
    set style(value: any) {
        this._setOption('style', value);
    }

    @Input()
    get textStyle(): any {
        return this._getOption('textStyle');
    }
    set textStyle(value: any) {
        this._setOption('textStyle', value);
    }


    protected get _optionPath() {
        return 'defaultItemProperties';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoDefaultItemPropertiesComponent
  ],
  exports: [
    DxoDefaultItemPropertiesComponent
  ],
})
export class DxoDefaultItemPropertiesModule { }
